// SMART DEMO — Vita Nova Network asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 skincare-products + 4 home-products + 4 business-model + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Vita Nova Network" tamamen kurgu demo markadır.

export const VITA_NOVA_NETWORK_ASSET_ROOT = "/demo-presets/network/vita-nova";

export interface VitaNovaNetworkManifest {
  logo: string;
  skincareProducts: string[];
  homeProducts: string[];
  businessModel: string[];
  videos: string[];
}

export const VITA_NOVA_NETWORK_MANIFEST: VitaNovaNetworkManifest = {
  logo: `${VITA_NOVA_NETWORK_ASSET_ROOT}/logo/logo.webp`,
  skincareProducts: [
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/skincare-products/01.webp`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/skincare-products/02.webp`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/skincare-products/03.webp`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/skincare-products/04.webp`,
  ],
  homeProducts: [
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/home-products/01.webp`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/home-products/02.webp`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/home-products/03.webp`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/home-products/04.webp`,
  ],
  businessModel: [
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/business-model/01.webp`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/business-model/02.webp`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/business-model/03.webp`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/business-model/04.webp`,
  ],
  videos: [
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/videos/01.mp4`,
    `${VITA_NOVA_NETWORK_ASSET_ROOT}/videos/02.mp4`,
  ],
};